import React  from 'react';
import PropTypes from 'prop-types';
import {push} from 'react-router-redux';
import Radium from 'radium';

import Menu from './Menu';
import {activateMenuItem, deactivateMenu} from '../menu/actions';


//@Radium
export default class MenuItem extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }
    static propTypes = {
        activePath: PropTypes.arrayOf(PropTypes.number).isRequired,
        text: PropTypes.string,
        items: PropTypes.arrayOf(PropTypes.object),
        action: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.func,
        ]),
    }
    static defaultProps = {
        style: () => {},
    }

    render() {
        const style = this.props.style;
        return <li key={this.props.index} style={style('MenuItem', this.props)}>
            {this.props.items
                ? <Menu {...this.props}/>
                : <span>
                    {this.props.action?.startsWith("http") ? (
                        <>
                            <a href={this.props.action} target="_blank" rel="noopener noreferrer" style={{ whiteSpace: 'nowrap', textDecoration: 'none' }}>
                                <i style={style('MenuItemIcon', this.props)} className={this.props.icon}></i>
                                <span style={style('MenuItemText', this.props)}>
                                    {this.props.text}
                                </span>
                            </a>
                        </>
                    ) : (
                        <>
                            <a
                                style={{whiteSpace: 'nowrap', textDecoration: 'none'}}
                                onClick={event => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    if (this.props.component) {
                                        this.context.store.dispatch(activateMenuItem(this.props.path, this.props.elementId));
                                    }
                                    else {
                                        this.context.store.dispatch(deactivateMenu(this.props.elementId));
                                        this.context.store.dispatch(push(this.props.action));
                                    }
                                }}>
                                {/* لیست منو هدر */}
                                <i style={style('MenuItemIcon', this.props)} className={this.props.icon}></i>
                                <span style={style('MenuItemText', this.props)}>
                                    {this.props.text}
                                </span>
                            </a>
                        </>
                    )}
                    {this.props.component
                        ? <div style={style('Component', this.props)}>
                            <this.props.component/>
                        </div>
                        : null
                    }
                </span>
            }
        </li>;
    }
};
